import { requests } from './baseServices'

export const ProjectServices = {    
    getAll: (criteria) => requests.get('api/projects', criteria),
    getAllWithOptions: (criteria) => requests.post('api/projects/filtered', criteria),
    getById: (id) => requests.get(`api/projects/${id}`),
    update: (id, template) => requests.put(`api/projects/${id}`, template),
    create: (template) => requests.post(`api/projects`, template),
    duplicate: (id) => requests.post(`api/projects/duplicate/${id}`),
    delete: (id) => requests.delete(`api/projects/${id}`),
    search: (query) => requests.get('api/projects/search', { query: query }),
};